<span *ngIf="isFilterCountPositive" class="filter-count-bubble">
  {{ _filterCount }}
</span>
